<template>
  <div class="medias">
    <div class="medias__loading" v-if="isLoading">
      <div class="lds-dual-ring"></div>
    </div>

    <div v-if="!isLoading && hasError" class="medias_error">
      <p>Une erreur est survenue.</p>
      <button @click="getProjectMedias">Refresh</button>
    </div>

    <div
      v-if="!isLoading && !medias.length && !hasError"
      class="medias__no-content"
    >
      <p>Aucun média disponible</p>
      <div class="upload">
        <input
          id="file"
          type="file"
          accept="image/png, image/jpg, image/jpeg"
          @change="uploadImage"
        />
      </div>
    </div>

    <!-- TODO: Add a nice fade effect transition -->
    <template v-if="!isLoading && medias.length">
      <div class="medias__gallery">
        <figure>
          <div class="file">
            <label for="image-upload" class="file__label">
              <input
                id="image-upload"
                type="file"
                class="file__input"
                accept="image/png, image/jpg, image/jpeg"
                @change="uploadImage"
              />
              <span class="file__cta">
                <div class="file__icon">
                  <i class="plus-icon"></i>
                </div>
              </span>
            </label>
          </div>
        </figure>
        <figure v-for="media in medias" :key="media.uuid">
          <img
            @click="handleMediaSelect(media.uuid, media.final_image)"
            class="gallery__image"
            :src="media.final_image"
            alt="image"
          />
          <div class="icon__container">
            <i class="ri-delete-bin-line"></i>
          </div>
        </figure>
      </div>

      <!-- TODO: Add a nice fade effect transition -->
      <div class="medias__preview">
        <p v-if="!selectedMedia">Cliquez sur une image pour la voir ici</p>

        <template v-if="selectedMedia && selectedMedia.src">
          <div class="preview__header">
            <v-btn
              outlined
              small
              color="secondary"
              class="mr-2"
              @click="handlePreviewClose"
              >Fermer</v-btn
            >
            <v-btn outlined small color="red" @click="destroyMedia"
              >Supprimer</v-btn
            >
          </div>

          <img
            class="gallery__image"
            v-if="selectedMedia && selectedMedia.src"
            :src="selectedMedia.src"
          />
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";

import ProjectsApi from "../../../repositories/projects";

export default {
  name: "MediasTab",
  data() {
    return {
      isLoading: false,

      hasError: false,

      medias: [],

      selectedImage: null,

      selectedMedia: null,

      imageToUpload: null,
      previewImage: null,

      snackbarShow: false,
      snackbarColor: "success",
      snackbarText: "",
    };
  },
  computed: {
    ...mapState({
      project: (state) => state.projects.project,
    }),
  },
  methods: {
    handlePreviewClose() {
      this.selectedMedia = null;
    },

    handleMediaSelect(media_uuid, media_src) {
      this.selectedMedia = {};
      this.selectedMedia.uuid = media_uuid;
      this.selectedMedia.src = media_src;
    },

    async uploadImage(event) {
      try {
        this.isLoading = true;
        const file = event.target.files[0];

        const payload = new FormData();
        payload.append("image", file);

        await ProjectsApi.postMedia(this.project.uuid, payload);

        this.$notify({
          type: "success",
          text: "Média envoyé",
        });

        // All good, refetch medias
        const { data } = await ProjectsApi.getMedias(this.project.uuid);
        this.medias = data;
      } catch (error) {
        console.log(error);

        if (error.response) {
          console.log(error.response.status);
          console.log(error.response.headers);
          console.log(error.response.data);

          if (error.response.status === 422) {
            this.$notify({
              type: "error",
              text:
                "<p>Vérifiez l'image</p><ul><li>Ne doit pas dépasser 2048Mo</li><li>Format accepté: png, jpg et jpeg</li></ul>",
              duration: 5000,
            });
          } else {
            this.$notify({
              type: "error",
              text: "Une erreur est survenue. Veuillez réessayer plus tard",
              duration: 5000,
            });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    async destroyMedia() {
      try {
        const hasConfirmed = confirm(
          "Voulez-vous vraiment supprimer ce média ? Attention: cette action est irréversible"
        );
        if (!hasConfirmed) return;

        this.isLoading = true;
        const media_uuid = this.selectedMedia.uuid;

        await ProjectsApi.destroyMedia(this.project.uuid, media_uuid);

        // All good, refetch medias
        const { data } = await ProjectsApi.getMedias(this.project.uuid);
        this.medias = data;

        this.selectedMedia = null;
      } catch (error) {
        console.log(error);

        if (error.response) {
          console.log(error.response.status);
          console.log(error.response.headers);
          console.log(error.response.data);
        }

        this.$notify({
          type: "error",
          text: "Une erreur est survenue. Veuillez réessayer plus tard",
        });
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Get project medias
     */
    async getProjectMedias() {
      try {
        this.hasError = false;
        this.isLoading = true;

        const { data } = await ProjectsApi.getMedias(this.project.uuid);

        this.medias = data;
      } catch (error) {
        if (error.response) {
          // Log errors
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);

          this.hasError = true;
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.getProjectMedias();
  },
};
</script>

<style lang="scss">
.medias {
  height: calc(100vh - 246px);
  position: relative;
  display: flex;
  justify-content: center;
}

.medias__loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($color: #000000, $alpha: 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 25px;
}

.medias__no-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  p {
    font-size: 1.5rem !important;
  }
}

.upload {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.upload__input {
  margin-right: 30px;
}

.medias__gallery {
  flex: 1;
  margin-right: 30px;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: repeat(8, 5vw);
  grid-gap: 15px;
  overflow: auto;

  .gallery__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 15px;
    cursor: pointer;
  }
}

.medias__preview {
  width: 40%;
  display: flex;
  max-width: 40%;
  flex: 1;
  position: relative;
  img {
    max-width: 100%;
    object-fit: cover;
  }
}

.preview__header {
  position: absolute;
  left: 10px;
  top: 10px;
  color: #fff;

  a {
    color: inherit !important;
  }
}

.preview__footer {
  position: absolute;
  bottom: 10px;
  left: 10px;

  color: #fff;

  a {
    color: inherit !important;
  }
}

// Upload CTA
.file {
  display: flex;
  justify-content: flex-start;
  position: relative;
  // align-items: stretch;
  font-size: 16px !important;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  height: 100%;
}

.file__label {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  height: 100%;
  width: 100%;
}

.file__input {
  position: absolute;
  height: 100%;
  width: 100%;
  outline: 0;
  top: 0;
  left: 0;
  opacity: 0;
}

.file__cta {
  display: inline-flex;
  flex-direction: column;
  height: auto;
  padding: 1em 3em;
  justify-content: center;
  align-items: center;
  position: relative;
  vertical-align: top;
  line-height: 1.5;
  border: 1px dashed #880e4f;
  border-radius: 15px;
  height: 100%;
  width: 100%;
  color: #880e4f;
}

.file__icon {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0.5em;
  height: 1.5em;
  width: 1.5em;
  color: inherit;
}

.plus-icon {
  font-size: 40px !important;
  color: inherit;

  &::before {
    content: "+";
  }
}

// Refactor
.lds-dual-ring {
  display: inline-block;
  width: 80px;
  height: 80px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid #880e4f;
  border-color: #880e4f transparent #880e4f transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
